
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../../utils/api";
import Button from "../../common/button/Button";
import { authSectionCard, AuthCardTopAccent } from "../common/authCard";
import AuthSubmitBar from "../common/AuthSubmitBar";

export default function Form() {
	const navigate = useNavigate();
	const [phoneNumber, setPhoneNumber] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");

	function sendVerificationCode() {
		if (isLoading) return;
		if (!isValidPhoneNumber()) {
			setErrorMessage("شماره همراه معتبر نیست");
			return;
		}
		setIsLoading(true);
		setErrorMessage("");
		api.profileLogin({
			phone_number: phoneNumber,
		})
			.then(() => {
				setIsLoading(false);
				navigate("/verify/?phone_number=" + encodeURIComponent(phoneNumber));
			})
			.catch((err) => {
				setIsLoading(false);
				if (err && err.data) {
					setErrorMessage(err.data.message);
				}
			});
	}

	function isValidPhoneNumber() {
		let isValid = true;
		if (phoneNumber.length !== 11 && phoneNumber.length !== 13) {
			isValid = false;
		}
		const isOnlyDigits = /^\d+$/.test(phoneNumber);
		if (!isOnlyDigits) {
			isValid = false;
		}
		if (!phoneNumber.startsWith("09")) {
			isValid = false;
		}
		if (isTestPhoneNumber()) {
			isValid = true;
		}
		return isValid;
	}

	function isTestPhoneNumber() {
		let isValid = true;
		if (phoneNumber.length !== 13) {
			isValid = false;
		}
		if (!phoneNumber.startsWith("0009")) {
			isValid = false;
		}
		return isValid;
	}

	return (
		<div className={[authSectionCard, "w-full flex flex-col gap-5"].join(" ")}>
			<AuthCardTopAccent />
			<p className="font-Vazir-400 text-[14px] text-midGray text-center leading-6 pt-1">
				با شماره همراه خود وارد شوید.
			</p>
			<div className="relative max-w-[300px] mx-auto w-full">
				<input
					type="tel"
					id="login-phone"
					value={phoneNumber}
					onChange={(e) => setPhoneNumber(e.target.value)}
					inputMode="numeric"
					autoComplete="tel"
					dir="ltr"
					className="w-full font-Vazir-400 rounded-xl border border-[#E2E8F0] px-4 pt-6 pb-3 text-[15px] text-midGray text-center tracking-wide focus:outline-none focus:border-darkBlue/40 focus:ring-2 focus:ring-darkBlue/10"
					placeholder="09123456789"
				/>
				<label
					htmlFor="login-phone"
					className="absolute right-4 -top-2.5 bg-white px-1 text-grayText font-Vazir-500 text-[13px]"
				>
					شماره همراه
				</label>
			</div>
			{errorMessage ? (
				<p className="text-center font-Vazir-400 text-[14px] text-error">{errorMessage}</p>
			) : null}
			<AuthSubmitBar>
				<Button
					onClick={() => {
						sendVerificationCode();
					}}
					label="ورود"
					isLoading={isLoading}
					className="h-full rounded-none rounded-b-xl"
					labelClassName="font-Vazir-700 text-[16px]"
				/>
			</AuthSubmitBar>
		</div>
	);
}
